import React from 'react';
import Button from '../components/Button';

const Schedule = () => {
    return (
        <>
            {/* Hero Section */}
            <section id="schedule-hero" className="hero" style={{ minHeight: '30vh' }}>
                <div className="hero-content">
                    <h1 className="hero-title">Class Schedule</h1>
                    <p className="hero-subtitle">Choose Your Preferred Batch Timing</p>
                </div>
            </section>

            {/* Schedule Section */}
            <section id="schedule" className="section section-dark">
                <div className="section-header">
                    <h2 className="section-title">Weekly Class Schedule</h2>
                    <p style={{ textAlign: 'center', fontSize: '1.2rem', color: 'var(--color-gray-light)', maxWidth: '800px', margin: '1rem auto' }}>
                        All classes are conducted live via Zoom with small batch sizes for personalized attention.
                    </p>
                </div>

                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Day</th>
                                <th>Batch 1 (Morning)</th>
                                <th>Batch 2 (Evening)</th>
                                <th>Batch 3 (Night)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td data-label="Day" title="Monday">Monday</td>
                                <td data-label="Batch 1 (Morning)" title="6:00 AM - 7:00 AM">6:00 AM - 7:00 AM</td>
                                <td data-label="Batch 2 (Evening)" title="6:00 PM - 7:00 PM">6:00 PM - 7:00 PM</td>
                                <td data-label="Batch 3 (Night)" title="9:00 PM - 10:00 PM">9:00 PM - 10:00 PM</td>
                            </tr>
                            <tr>
                                <td data-label="Day" title="Tuesday">Tuesday</td>
                                <td data-label="Batch 1 (Morning)" title="6:00 AM - 7:00 AM">6:00 AM - 7:00 AM</td>
                                <td data-label="Batch 2 (Evening)" title="6:00 PM - 7:00 PM">6:00 PM - 7:00 PM</td>
                                <td data-label="Batch 3 (Night)" title="9:00 PM - 10:00 PM">9:00 PM - 10:00 PM</td>
                            </tr>
                            <tr>
                                <td data-label="Day" title="Wednesday">Wednesday</td>
                                <td data-label="Batch 1 (Morning)" title="6:00 AM - 7:00 AM">6:00 AM - 7:00 AM</td>
                                <td data-label="Batch 2 (Evening)" title="6:00 PM - 7:00 PM">6:00 PM - 7:00 PM</td>
                                <td data-label="Batch 3 (Night)" title="9:00 PM - 10:00 PM">9:00 PM - 10:00 PM</td>
                            </tr>
                            <tr>
                                <td data-label="Day" title="Thursday">Thursday</td>
                                <td data-label="Batch 1 (Morning)" title="6:00 AM - 7:00 AM">6:00 AM - 7:00 AM</td>
                                <td data-label="Batch 2 (Evening)" title="6:00 PM - 7:00 PM">6:00 PM - 7:00 PM</td>
                                <td data-label="Batch 3 (Night)" title="9:00 PM - 10:00 PM">9:00 PM - 10:00 PM</td>
                            </tr>
                            <tr>
                                <td data-label="Day" title="Friday">Friday</td>
                                <td data-label="Batch 1 (Morning)" title="6:00 AM - 7:00 AM">6:00 AM - 7:00 AM</td>
                                <td data-label="Batch 2 (Evening)" title="6:00 PM - 7:00 PM">6:00 PM - 7:00 PM</td>
                                <td data-label="Batch 3 (Night)" title="9:00 PM - 10:00 PM">9:00 PM - 10:00 PM</td>
                            </tr>
                            <tr>
                                <td data-label="Day" title="Saturday">Saturday</td>
                                <td data-label="Batch 1 (Morning)" title="7:00 AM - 8:00 AM">7:00 AM - 8:00 AM</td>
                                <td data-label="Batch 2 (Evening)" title="5:00 PM - 6:00 PM">5:00 PM - 6:00 PM</td>
                                <td data-label="Batch 3 (Night)" title="8:00 PM - 9:00 PM">8:00 PM - 9:00 PM</td>
                            </tr>
                            <tr>
                                <td data-label="Day" title="Sunday">Sunday</td>
                                <td data-label="Batch 1 (Morning)" title="7:00 AM - 8:00 AM">7:00 AM - 8:00 AM</td>
                                <td data-label="Batch 2 (Evening)" title="5:00 PM - 6:00 PM">5:00 PM - 6:00 PM</td>
                                <td data-label="Batch 3 (Night)" title="8:00 PM - 9:00 PM">8:00 PM - 9:00 PM</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div style={{ textAlign: 'center', marginTop: '1.25rem', maxWidth: '760px', margin: '1.25rem auto 0' }}>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '2rem' }}>
                        <strong style={{ color: 'var(--color-gold-light)' }}>Note:</strong> Times are in Indian Standard Time (IST).
                        International students can choose batches that fit their timezone. All classes are recorded and available for replay.
                    </p>
                    <Button to="/registration" style={{ marginRight: '1rem' }}>Register for Classes</Button>
                    <Button to="/contact" variant="secondary">Contact for Custom Timing</Button>
                </div>
            </section>
        </>
    );
};

export default Schedule;
